// Fonctions de gestion des utilisateurs hors ligne
import { userDb } from '../config/pouch';
import { hashPassword } from './passwordHash';

export const saveUserEmailForOffline = async (email, password = null, additionalData = {}) => {
    if (!email) {
        throw new Error('Email requis pour la sauvegarde');
    }

    try {
        let existingDoc = null;
        try {
            existingDoc = await userDb.get(email.toLowerCase());
        } catch (err) {
            if (err.status !== 404) {
                throw err;
            }
        }

        // Le mot de passe n'est jamais stocké en clair : on conserve uniquement
        // un hash PBKDF2. Si aucun mot de passe n'est fourni (ex. rafraîchissement
        // de session), on préserve le hash déjà enregistré.
        let passwordHash = existingDoc ? existingDoc.passwordHash || null : null;
        if (password) {
            passwordHash = await hashPassword(password);
        }

        const user = {
            _id: email.toLowerCase(),
            email: email.toLowerCase(),
            passwordHash,
            lastSync: new Date().toISOString(),
            ...additionalData
        };

        if (existingDoc) {
            user._rev = existingDoc._rev;
        }

        await userDb.put(user);
        return true;
    } catch (error) {

        throw error;
    }
};

export const checkOfflineUserEmail = async (email) => {
    if (!email) return null;

    try {
        const doc = await userDb.get(email.toLowerCase());
        return doc;
    } catch (error) {
        if (error.status === 404) {
            return null;
        }
        throw error;
    }
};

export const getAvailableOfflineEmails = async () => {
    try {
        const result = await userDb.allDocs({
            include_docs: true
        });
        return result.rows
            .map(row => row.doc)
            .filter(doc => doc.email)
            .map(doc => doc.email);
    } catch (error) {

        return [];
    }
};

export const removeOfflineUser = async (email) => {
    if (!email) return;

    try {
        const doc = await userDb.get(email.toLowerCase());
        await userDb.remove(doc);
        return true;
    } catch (error) {
        return false;
    }
};

export const cleanOldOfflineUsers = async (daysOld = 30) => {
    try {
        const result = await userDb.allDocs({ include_docs: true });
        const cutoffDate = new Date();
        cutoffDate.setDate(cutoffDate.getDate() - daysOld);

        const usersToDelete = result.rows
            .map(row => row.doc)
            .filter(doc => {
                if (!doc.lastSync) return false;
                const lastSyncDate = new Date(doc.lastSync);
                return lastSyncDate < cutoffDate;
            });

        for (const user of usersToDelete) {
            try {
                await userDb.remove(user);
            } catch (error) {
            }
        }

        return usersToDelete.length;
    } catch (error) {
        return 0;
    }
};

export const updateUserLastSync = async (email) => {
    if (!email) return false;

    try {
        const doc = await userDb.get(email.toLowerCase());
        doc.lastSync = new Date().toISOString();
        await userDb.put(doc);
        return true;
    } catch (error) {
        return false;
    }
};

